import { types, query } from 'typed-graphqlify';
import { gql } from '@apollo/client';

export const locationIntegrationsInitQuery = gql`
  ${query({
    locations: [
      {
        id: types.string,
        name: types.string,
      },
    ],
  })}
`;
